import React, { useMemo } from "react";

import { Table } from "clearsense-ui/components";

import { COLUMN_DATA } from "./columns";
import { getTableData } from "./data";

const PredictionsTable = ({ summary, output, isLoading }) => {
  const data = useMemo(
    () => summary && output && getTableData(summary, output),
    [summary, output]
  );

  return (
    <div className="p-2 bg-white dark:bg-cs-ui-gray-800">
      <Table rowData={data} isLoading={isLoading} columnData={COLUMN_DATA} />
    </div>
  );
};

export default PredictionsTable;
